import { createContext } from 'react';

export type ImageLoading = {
  eager?: boolean;
  fetchPriority?: 'high';
};

/**
 * Lets a list opt the images it shows on first paint out of lazy loading, without threading props
 * through every tile presentation. `ImageWithDefault` reads it; images outside a provider stay lazy.
 */
export const ImageLoadingContext = createContext<ImageLoading>({});

export const eagerImageLoading: ImageLoading = { eager: true };

export const priorityImageLoading: ImageLoading = { eager: true, fetchPriority: 'high' };
